import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PreviousStepButton extends Vue {
    @Prop(Boolean)
    fullWidth: boolean;
}
